import { useMsal } from "@azure/msal-react";
import styles from "../Login/styles.module.css";

type AppErrorProps = {
  onRetry: () => void;
};

export const AppError = ({ onRetry }: AppErrorProps) => {
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginWrapper}>
        <h1>Something went wrong</h1>
        <p>
          We were unable to load your account. This may be a temporary issue —
          please try again.
        </p>
        <button onClick={onRetry}>Try again</button>
        <button onClick={handleLogout}>Sign out</button>
      </div>
    </div>
  );
};
